import Pager from '../elements/pager';
import Filter from './filters/filter';
import FilterGroup from './filters/filterGroup';
import NoResults from '../elements/noResults';
import { createBrowserHistory } from 'history';

export default class PagedOverviewController {
    constructor(container) {
        /** @type {Element} */
        this.container = container;

        /** @type {Array.Element} */
        this.items = [];

        this.itemsPerPage = parseInt(this.container.dataset.itemsPerPage) || 12;

        /** @type {Pager} */
        this.pager = null;

        this.translations = {
            noResultsFound: 'Geen resultaten gevonden',
        };

        /** @type {Filter} */
        this.filter = null;
        /** @type {FilterGroup} */
        this.filterGroup = null;

        this.history = createBrowserHistory();

        this.init();
    }

    init() {
        for (let i = 0; i < this.container.querySelector('.targets').children.length; i++) {
            this.items.push(this.container.querySelector('.targets').children[i]);
        }

        this.pager = new Pager();
        if (this.container.dataset.pagerButtonLabelNext) {
            this.pager.nextLabel = this.container.dataset.pagerButtonLabelNext;
        }
        if (this.container.dataset.pagerLabelPrev) {
            this.pager.prevTitle = this.container.dataset.pagerLabelPrev;
        }
        if (this.container.dataset.pagerLabelNext) {
            this.pager.nextTitle = this.container.dataset.pagerLabelNext;
        }
        if (this.container.dataset.pagerLabelOf) {
            this.pager.ofLabel = this.container.dataset.pagerLabelOf;
        }

        if (this.container.dataset.noResultsFoundLabel) {
            this.translations.noResultsFound = this.container.dataset.noResultsFoundLabel;
        }

        // Filter setup
        if (this.container.classList.contains('hasFilters')) {
            this.filter = new Filter(this.container.querySelector('section.filters'));
            this.filter.additive = true;
            
            this.filterGroup = new FilterGroup([this.filter], this.items);
            this.filterGroup.init();
        }

        this.loadFromUrl();

        if (this.filter) {
            this.filter.init();
            this.filterGroup.decideOnAllFilterTargets();
        }

        if (this.container.querySelector('.pagerContainer')) {
            this.container.querySelector('.pagerContainer').appendChild(this.pager.getOrCreate());
        }

        this.updatePager();

        this.setEventListeners();
    }

    updatePager() {
        // Calculate amount of items to show
        let items = this.items.filter(target => !target.classList.contains('filtered'));
        const shownItems = [];

        // Calculate total pages
        this.pager.totalPages = Math.ceil(items.length / this.itemsPerPage);

        // Update pager to ensure selected pages are possible
        if (this.pager.currentPage > this.pager.totalPages) {
            this.pager.currentPage = this.pager.totalPages;
        }

        if (this.pager.currentPage < 1) {
            this.pager.currentPage = 1;
        }

        // Calculate indexes needed to be shown
        let startingIndex = Math.max(0, (this.pager.currentPage - 1) * this.itemsPerPage);
        let endingIndex = startingIndex + this.itemsPerPage - 1;

        items.forEach((item, index) => {
            if (index >= startingIndex && index <= endingIndex) {
                shownItems.push(item);
            }
        });

        this.items.forEach(item => {
            if (shownItems.includes(item)) {
                item.classList.remove('paged');

                item.classList.add('animating');
                setTimeout(() => {
                    item.classList.remove('animating');
                }, 400);

            } else {
                item.classList.add('paged');
            }
        });

        this.container.querySelectorAll('.noResultsSection').forEach(section => section.remove());
        if (!shownItems.length) {
            let section = new NoResults({
                message: this.translations.noResultsFound,
            });
            section._template = require('../elements/templates/noResultsPaged.handlebars');

            this.container.querySelector('.targets').appendChild(section.getOrCreate());
        }
    }

    loadFromUrl() {
        const url = new URL(location.href);
        
        if (this.container.querySelector('section.filters[data-key]')) {
            let key = this.container.querySelector('section.filters[data-key]').dataset.key;
            if (url.searchParams.get(key)) {
                let selectedOptions = url.searchParams.get(key).toString().split(',');
                this.container.querySelectorAll('section.filters[data-key] input').forEach(input => {
                    if (selectedOptions.includes(input.value)) {
                        input.setAttribute('checked', 'checked');
                    }
                });
            }
        }

        if (url.searchParams.get('page')) {
            this.pager.currentPage = url.searchParams.get('page');
        }
    }

    updateUrl() {
        let search = '';

        if (this.pager.currentPage > 1) {
            search = `page=${this.pager.currentPage}`;
        }

        if (this.filter && this.filter.selected.length) {
            if (search) {
                search += `&`;
            }

            search += `${this.filter.name}=${this.filter.selected.map(val => encodeURIComponent(val))}`;
        }

        this.history.replace({
            search: search ? `?${search}` : ''
        });
    }

    scrollToTop() {
        const scrollPosition = app.elementCoords(this.container).top - (window.innerWidth > app.breakpoints.md.size ? 150 : 70);
        window.scrollTo({
            top: scrollPosition,
            behavior: 'smooth',
        });
    }

    setEventListeners() {
        this.pager.getOrCreate().addEventListener('prev', e => {
            if (this.pager.currentPage > 1) {
                this.scrollToTop();

                setTimeout(() => {
                    this.pager.currentPage--;
                    this.updateUrl();
                    this.updatePager();
                }, 200);
            }
        });

        this.pager.getOrCreate().addEventListener('next', e => {
            if (this.pager.currentPage < this.pager.totalPages) {
                this.scrollToTop();

                setTimeout(() => {
                    this.pager.currentPage++;
                    this.updateUrl();
                    this.updatePager();
                }, 200);
            }
        });

        if (this.filter) {
            this.filter.element.addEventListener('update', e => {
                this.pager.currentPage = 1;

                this.updateUrl();
                this.updatePager();
            });
        }
    }
}